import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import FormLayout from 'src/layouts/form';
// components
import { LoadingScreen } from 'src/components/loading-screen';
// ----------------------------------------------------------------------

const DashboardLayoutStore = lazy(() =>
  import('src/layouts/dashboard/layout').then((module) => ({ default: module.DashboardLayoutStore }))
);
const EditSubscriptionStore = lazy(() =>
  import('src/pages/subscription/editSubscription').then((module) => ({ default: module.EditSubscriptionStore }))
);
const DocumentByParticipantStore = lazy(() =>
  import('src/pages/document/documentByParticipant').then((module) => ({
    default: module.DocumentByParticipantStore,
  }))
);
const DocumentFilloutStore = lazy(() =>
  import('src/pages/document/documentFillout').then((module) => ({
    default: module.DocumentFilloutStore,
  }))
);
const DocumentViewStore = lazy(() =>
  import('src/pages/document/documentView').then((module) => ({
    default: module.DocumentViewStore,
  }))
);
const ParticipantByDocumentStore = lazy(() =>
import('src/pages/document/ParticipantByDocument').then((module) => ({
  default: module.ParticipantByDocumentStore,
}))
);

const OrganismeView = lazy(() => import('src/pages/subscription/organismeView'));

const PricingViewStore = lazy(() =>
  import('src/pages/subscription/pricingView').then((module) => ({
    default: module.PricingViewStore,
  }))
);

const PaymentViewStore = lazy(() =>
  import('src/pages/subscription/paymentView').then((module) => ({
    default: module.PaymentViewStore,
  }))
);

const SubscriptionTabStore = lazy(() =>
  import('src/components/subscription/tabs/SubscriptionTab').then((module) => ({
    default: module.SubscriptionTabStore,
  }))
);

const GoCardlessCallbackPage= lazy(() => import('src/pages/subscription/GoCardlessCallbackPage'));
const InvoiceDetailsView = lazy(() => import('src/pages/invoice/view/invoice-details-view'));
const AllInvoiceView = lazy(() => import('src/pages/subscription/invoices'));

// ----------------------------------------------------------------------

export const SubscriptionAdminRoutes = [
  {
    path: 'subscriptions/admin',
    element: (
      <AuthGuard allowedRoles={['administrator']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { element: <SubscriptionTabStore />, index: true },
      { path: 'pricing', element: <PricingViewStore /> },
      { path: 'payment', element: <PaymentViewStore /> },
      { path: 'organization', element: <OrganismeView /> }, 
      { path: 'edition', element: <EditSubscriptionStore /> },
      { path: 'invoice', element: <InvoiceDetailsView /> },
      { path: 'all-invoices', element: <AllInvoiceView /> },
    ],
  },
];

export const SubscriptionGocardlessRoutes = [
  {
    path: 'gocardless',
    element: (
      <AuthGuard allowedRoles={['organization', 'administrator']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { path: 'callback', element: <GoCardlessCallbackPage /> },
      { path: 'cancel', element: <PaymentViewStore /> },
    ],
  },
];

export const SubscriptionOrgRoutes = [
  {
    path: 'subscriptions',
    element: (
      <AuthGuard allowedRoles={['organization']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { path: 'pricing', element: <PricingViewStore /> },
      { path: 'payment', element: <PaymentViewStore /> },
    ],
  },
];
